const SITE_URL = process.env.REACT_APP_SITE_URL;

export default function localBusinessSchema() {
  return {
    "@context": "https://schema.org",

    "@type": "LocalBusiness",

    "@id": `${SITE_URL}/#localbusiness`,

    name: "Money Mart",

    image: `${SITE_URL}/og-image.jpg`,

    url: SITE_URL,

    telephone: "+91-9214417434",

    email: "contact@money-mart.in",

    address: {
      "@type": "PostalAddress",
      streetAddress:
        "1st A-B Rd, Opposite Gold Plaza, Sardarpura",
      addressLocality: "Jodhpur",
      addressRegion: "Rajasthan",
      postalCode: "342003",
      addressCountry: "IN",
    },

    openingHoursSpecification: [
      {
        "@type": "OpeningHoursSpecification",
        dayOfWeek: [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday"
        ],
        opens: "10:00",
        closes: "19:00",
      }
    ],

    parentOrganization: {
      "@id": `${SITE_URL}/#organization`
    }
  };
}